<template>
    <div id="content" style="width:100%;font-family: Epilogue, Epilogue;color: #FFFFFF;display:flex;flex-flow:column wrap;">
        <header v-if="seen" style="width:100%;height: 100px;padding: 0 140px;box-sizing:border-box;background: #014DFE;">
            <div style="width:100%;height: 98px;border-bottom:1px solid #fff;display:flex;justify-content:space-between;align-items:center;">
                <div style="font-size: 28px;font-weight: 500;">AVATOR</div>
                <div>
                    <span @click="scrollTo('aa')" style="font-size: 18px;margin-left:43px;cursor: pointer;">Company Profile</span>
                    <span @click="scrollTo('bb')" style="font-size: 18px;margin-left:43px;cursor: pointer;">Business Introduction</span>
                    <span @click="scrollTo('cc')" style="font-size: 18px;margin-left:43px;cursor: pointer;">Enterprise Culture</span>
                </div>
            </div>
        </header>
        <header v-else style="width:100%;height: 100px;padding: 0 140px;box-sizing:border-box;background: #014DFE;">
            <div style="width:100%;height: 98px;border-bottom:1px solid #fff;display:flex;justify-content:space-between;align-items:center;">
                <div style="font-size: 28px;font-weight: 500;">AVATOR</div>
                <div>
                    <span @click="scrollTo('aa')" style="font-size: 25px;margin-left:43px;cursor: pointer;">Company Profile</span>
                    <span @click="scrollTo('bb')" style="font-size: 25px;margin-left:43px;cursor: pointer;">Business Introduction</span>
                    <span @click="scrollTo('cc')" style="font-size: 25px;margin-left:43px;cursor: pointer;">Enterprise Culture</span>
                </div>
            </div>
        </header>

        <section v-if="seen" style="position: relative;width:100%;height: 1262px;padding: 0 140px;box-sizing:border-box;background: #014DFE;display:flex;flex-flow:column nowrap;align-items:center;">
            <div style="width:100%;font-size: 100px;font-weight: 600;line-height: 162px;padding-top:100px;">
                <div>Digital Marketing </div>
                <div>Information Technology</div>
            </div>
            <div style="width:100%;padding-top:60px;">
                <p style="font-size: 24px;font-weight: 400;">AVATOR TECHNOLOGY PTE. LTD.</p>
                <p @click="scrollTo('aa')" style="cursor: pointer;margin-top:60px;width: 181px;height: 60px;line-height:60px;border-radius: 100px 100px 100px 100px;background: #FFFFFF;font-size: 18px;color: #000000;font-weight: bold;text-align: center;">Get Started</p>
            </div>
            <img src="../../static/avator/Rectangle 748 (1).png" alt="" style="position:absolute;right:0;bottom:0;width:1200px;">
        </section>
        <section v-else style="position: relative;width:100%;height: 1262px;padding: 0 140px;box-sizing:border-box;background: #014DFE;display:flex;flex-flow:column nowrap;align-items:center;">
            <div style="width:100%;font-size: 100px;font-weight: 600;line-height: 162px;padding-top:100px;">
                <div>Digital Marketing </div>
                <div>Information Technology</div>
            </div>
            <div style="width:100%;padding-top:60px;">
                <p style="font-size: 24px;font-weight: 400;">AVATOR TECHNOLOGY PTE. LTD.</p>
                <p @click="scrollTo('aa')" style="cursor: pointer;margin-top:60px;width: 181px;height: 60px;line-height:60px;border-radius: 100px 100px 100px 100px;background: #FFFFFF;font-size: 18px;color: #000000;font-weight: bold;text-align: center;">Get Started</p>
            </div>
            <img src="../../static/avator/Rectangle 748 (1).png" alt="" style="position:absolute;right:0;bottom:0;width:1200px;">
        </section>

        <!-- 公司简介 -->
        <section id="aa">
            <template v-if="seen">
                <div style="width:100%;padding: 0 140px;box-sizing:border-box;background: #fff;color:#000;display:flex;flex-flow:column nowrap;align-items:center;">
                    <div style="position: relative;width:100%;height:340px;font-size: 100px;font-weight: 600;line-height: 156px;margin-top:240px;">
                        <div style="display:block;">Company </div>
                        <div style="display:block;">Profile</div>  
                        <!-- <span style="position:absolute;right:0;bottom:0;font-size: 30px;">Number One</span> -->
                    </div>
                    <div style="margin-top:40px;background: #151515;width:100%;display:flex;flex-flow:row nowrap;justify-content:center;align-items:center;">
                        <img src="../../static/avator/Mask group.png" alt="" style="width:815px;padding:29px;">
                        <div style="font-size: 25px;font-weight: 400;color: #FFFFFF;padding:60px;line-height: 36px;">
                            We are a company specializing in digital marketing and information technology services, providing our clients with a full range of solutions to help them succeed in a competitive marketplace.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div style="width:100%;padding: 0 140px;box-sizing:border-box;background: #fff;color:#000;display:flex;flex-flow:column nowrap;align-items:center;">
                    <div style="position: relative;width:100%;height:340px;font-size: 100px;font-weight: 600;line-height: 156px;margin-top:240px;">
                        <div style="display:block;">Company </div>
                        <div style="display:block;">Profile</div>  
                        <!-- <span style="position:absolute;right:0;bottom:0;font-size: 30px;">Number One</span> -->
                    </div>
                    <div style="margin-top:40px;background: #151515;width:100%;display:flex;flex-flow:row nowrap;justify-content:center;align-items:center;">
                        <img src="../../static/avator/Mask group.png" alt="" style="width:815px;padding:29px;">
                        <div style="font-size: 25px;font-weight: 400;color: #FFFFFF;padding:60px;line-height: 36px;">
                            We are a company specializing in digital marketing and information technology services, providing our clients with a full range of solutions to help them succeed in a competitive marketplace.
                        </div>
                    </div>
                </div>
            </template>
        </section>
        
        <!-- 业务介绍 -->
        <section id="bb">
            <template v-if="seen">
                <div style="width:100%;padding: 0 140px;box-sizing:border-box;background: #fff;color:#000;display:flex;flex-flow:column nowrap;align-items:center;">
                    <div style="position: relative;width:100%;height:340px;font-size: 100px;font-weight: 600;line-height: 156px;margin-top:240px;">
                        <div style="display:block;">Business  </div>
                        <div style="display:block;">Introduction</div>  
                        <!-- <span style="position:absolute;right:0;bottom:0;font-size: 30px;">Second</span> -->
                    </div>
                    <div style="margin-top:40px;color: #000000;width:100%;display:flex;flex-flow:row nowrap;justify-content:space-between;align-items:center;">
                        <div v-for="(item,index) in ywList" :key="index" style="width:49%;">
                            <img :src="item.img" alt="" style="width:100%;height:100%;">
                            <div style="font-size: 30px;font-weight: 500;line-height: 36px;margin:20px 0;">
                                {{item.title}}
                            </div>
                            <div style="font-size: 20px;font-weight: 400;line-height: 30px;">
                                {{item.content[0]}}
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div style="width:100%;padding: 0 140px;box-sizing:border-box;background: #fff;color:#000;display:flex;flex-flow:column nowrap;align-items:center;">
                    <div style="position: relative;width:100%;height:340px;font-size: 100px;font-weight: 600;line-height: 156px;margin-top:240px;">
                        <div style="display:block;">Business  </div>
                        <div style="display:block;">Introduction</div>  
                        <!-- <span style="position:absolute;right:0;bottom:0;font-size: 30px;">Second</span> -->
                    </div>
                    <div style="margin-top:40px;color: #000000;width:100%;display:flex;flex-flow:row nowrap;justify-content:space-between;align-items:center;">
                        <div v-for="(item,index) in ywList" :key="index" style="width:49%;">
                            <img :src="item.img" alt="" style="width:100%;height:100%;">
                            <div style="font-size: 34px;font-weight: 500;line-height: 36px;margin:20px 0;">
                                {{item.title}}
                            </div>
                            <div style="font-size: 28px;font-weight: 400;line-height: 30px;">
                                {{item.content[0]}}
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </section>

        <!-- 企业文化 -->
        <section id="cc">
            <template v-if="seen">
                <div style="width:100%;height: 1488px;padding: 0 140px;box-sizing:border-box;background: #014DFE;color: #FFFFFF;display:flex;flex-flow:column nowrap;align-items:center;margin-top:240px;">
                    <div style="position: relative;width:100%;height:340px;font-size: 100px;font-weight: 600;line-height: 156px;padding-top:100px;">
                        <div style="display:block;">Company </div>
                        <div style="display:block;">Culture</div>  
                        <!-- <span style="position:absolute;right:0;bottom:0;font-size: 30px;">Third.</span> -->
                    </div>
                    <div style="margin-top:40px;width:100%;display:flex;flex-flow:row nowrap;justify-content:space-between;align-items:center;">
                        <div style="width:50%;margin-top:40px;display:flex;flex-flow:row nowrap;justify-content:space-between;align-items:center;">
                            <div>
                                <img :src="qyList[ywActive].img" alt="" style="width:795px;height:563px;">
                                <div style="font-size: 30px;font-weight: 500;line-height: 36px;margin:20px 0;">
                                    {{qyList[ywActive].title}}
                                </div>
                                <div style="height:100px;font-size: 20px;font-weight: 400;line-height: 30px;">
                                    {{qyList[ywActive].content[0]}}
                                </div>
                            </div>
                        </div>
                        <div style="width:40%;align-self:end;border-bottom: 1px solid #FFFFFF;">
                            <div v-for="(item,index) in qyList" :key="index" style="width:100%;height:100px;line-height: 100px;display:flex;flex-flow:column nowrap;">
                                <div @mouseenter="ywActive=index" @mouseleave="ywActive=index" class="hvr-icon-grow" style="font-size: 40px;font-weight: 600;border-top: 1px solid #FFFFFF;cursor: pointer;">
                                    {{item.title}}
                                    <img src="../../static/avator/Arrow 11.png" alt="" class="hvr-icon" style="float:right;margin-top:40px;">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div style="width:100%;height: 1488px;padding: 0 140px;box-sizing:border-box;background: #014DFE;color: #FFFFFF;display:flex;flex-flow:column nowrap;align-items:center;margin-top:240px;">
                    <div style="position: relative;width:100%;height:340px;font-size: 100px;font-weight: 600;line-height: 156px;padding-top:100px;">
                        <div style="display:block;">Company </div>
                        <div style="display:block;">Culture</div>  
                        <!-- <span style="position:absolute;right:0;bottom:0;font-size: 30px;">Third.</span> -->
                    </div>
                    <div style="margin-top:40px;width:100%;display:flex;flex-flow:row nowrap;justify-content:space-between;align-items:center;">
                        <div style="width:50%;margin-top:40px;display:flex;flex-flow:row nowrap;justify-content:space-between;align-items:center;">
                            <div>
                                <img :src="qyList[ywActive].img" alt="" style="width:795px;height:563px;">
                                <div style="font-size: 36px;font-weight: 500;line-height: 36px;margin:20px 0;">
                                    {{qyList[ywActive].title}}
                                </div>
                                <div style="height:100px;font-size: 28px;font-weight: 400;line-height: 30px;">
                                    {{qyList[ywActive].content[0]}}
                                </div>
                            </div>
                        </div>
                        <div style="width:40%;align-self:end;border-bottom: 1px solid #FFFFFF;">
                            <div v-for="(item,index) in qyList" :key="index" style="width:100%;height:100px;line-height: 100px;display:flex;flex-flow:column nowrap;">
                                <div @mouseenter="ywActive=index" @mouseleave="ywActive=index" class="hvr-icon-grow" style="font-size: 40px;font-weight: 600;border-top: 1px solid #FFFFFF;cursor: pointer;">
                                    {{item.title}}
                                    <img src="../../static/avator/Arrow 11.png" alt="" class="hvr-icon" style="float:right;margin-top:40px;">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </section>

        <div v-if="seen" style="width: 100%;height: 360px;padding: 0 140px;box-sizing:border-box;font-size: 20px;background: #151515;color:white;display:flex;justify-content:space-between;align-items:center;">
            <div style="flex:3;height: 360px;padding: 50px 0;box-sizing:border-box;display:flex;flex-flow:column nowrap;justify-content:space-around;">
                <div style="font-size: 28px;font-weight: 500;">AVATOR</div>
                <div>&nbsp;</div>
            </div>
            <div style="width:650px;height: 360px;padding: 50px 0;box-sizing:border-box;display:flex;flex-flow:column nowrap;justify-content:space-around;">
                <div>
                    <span @click="scrollTo('aa')" style="font-size: 18px;margin-right:40px;cursor: pointer;">Company Profile</span>
                    <span @click="scrollTo('bb')" style="font-size: 18px;margin-right:40px;cursor: pointer;">Business Introduction</span>
                    <span @click="scrollTo('cc')" style="font-size: 18px;margin-right:40px;cursor: pointer;">Enterprise Culture</span>
                </div>
                <div>Email：contact@avator-tech.com</div>
            </div>
            <div style="width:400px;height: 360px;padding: 50px 0;box-sizing:border-box;display:flex;flex-flow:column nowrap;justify-content:space-around;">
                <div>AVATOR TECHNOLOGY PTE. LTD.</div>
                <div>&nbsp;</div>
            </div>
        </div>
        <div v-else style="width: 100%;height: 360px;padding: 0 140px;box-sizing:border-box;font-size: 25px;background: #151515;color:white;display:flex;justify-content:space-between;align-items:center;">
            <div style="flex:3;height: 360px;padding: 50px 0;box-sizing:border-box;display:flex;flex-flow:column nowrap;justify-content:space-around;">
                <div style="font-size: 34px;font-weight: 500;">AVATOR</div>
                <div>&nbsp;</div>
            </div>
            <div style="width:850px;height: 360px;padding: 50px 0;box-sizing:border-box;display:flex;flex-flow:column nowrap;justify-content:space-around;">
                <div>
                    <span @click="scrollTo('aa')" style="font-size: 25px;margin-right:40px;cursor: pointer;">Company Profile</span>
                    <span @click="scrollTo('bb')" style="font-size: 25px;margin-right:40px;cursor: pointer;">Business Introduction</span>
                    <span @click="scrollTo('cc')" style="font-size: 25px;margin-right:40px;cursor: pointer;">Enterprise Culture</span>
                </div>
                <div>Email：contact@avator-tech.com</div>
            </div>
            <div style="width:400px;height: 360px;padding: 50px 0;box-sizing:border-box;display:flex;flex-flow:column nowrap;justify-content:space-around;">
                <div>AVATOR TECHNOLOGY PTE. LTD.</div>
                <div>&nbsp;</div>
            </div>
        </div>
        
    </div>
</template>
<script>
    import autofit from 'autofit.js'
    export default {
        name: 'Index',
        data() {
            return {
                carousel_height: '47vw',
                seen: true,
                sliders: [],
                // 业务介绍
                ywActive: 0,
                ywList: [
                    {
                        index: 0,
                        icon: require('../assets/images/icon2.png'),
                        img: require('../../static/avator/Rectangle 75422.png'),
                        bg: '#fba45b',
                        title: "Advertising Placement",
                        content: ["We provide advertising services for customers, develop whole-case marketing plans according to their needs and goals, and use media platforms such as Facebook, Google and TikTok for advertising, so as to ensure that advertising can cover the target audience and effectively convey the brand value and marketing information of customers. At the same time, through its own traffic channels and cooperation with APP developers, it collects advertising traffic realization fees to provide customers with more exposure and returns."]
                    },
                    {
                        index: 1,
                        icon: require('../assets/images/icons1.png'),
                        img: require('../../static/avator/Group 43111.png'),
                        bg: '#2f97be',
                        title: "Information Technology Service",
                        content: ["We provide a series of information technology services to support their business development through customized needs for customers, including but not limited to information technology consulting, operation and maintenance services, functional testing, interface testing, etc., committed to helping customers optimize their information technology architecture, improve the stability and security of the system, and through technological innovation and optimization, bring more revenue and growth to our customers."]
                    }
                ],
                // 企业文化
                qyActive: null,
                qyList: [
                    {
                        img: require('../../static/avator/Rectangle 754(1).png'),
                        title: "Innovation Drive",
                        content: ["Focus on the use of the latest technology and innovative methods, constantly optimize the effect of advertising, improve the ability to monetize advertising traffic, to meet the changing market demand."]
                    },
                    {
                        img: require('../../static/avator/Rectangle 7542.png'),
                        title: "Professional Services",
                        content: ["Provide professional information technology services, including consulting, operation and maintenance, functional testing and interface testing, etc., in order to ensure that customers' technical needs are met efficiently and accurately."]
                    },
                    {
                        img: require('../../static/avator/Rectangle 754 3.png'),
                        title: "Win-Win Cooperation",
                        content: ["We advocate the establishment of long-term, stable cooperative relationships with customers, partners and employees to achieve common development through the sharing of resources and mutual benefit."]
                    },
                    {
                        img: require('../../static/avator/Rectangle 7544.png'),
                        title: "Quality First",
                        content: ["Insisting on high standards of service quality, we ensure that every project is executed to the best level in the industry to win the trust of our clients and the recognition of the market."]
                    },
                ],
            }
        },
        methods: {
            scrollTo(type) {
                document.getElementById(type).scrollIntoView()
            },
            menuSeen(){
                // 屏幕尺寸
                let screenHeight=document.body.clientWidth;
                if(screenHeight>415){
                    this.seen=true;
                }else{
                    this.seen=false;
                }
            },
        },
        mounted() {
            this.menuSeen();
            this.sliders = [
                {
                    img: require('../assets/images/a4.jpg')
                },
            ]
            // window.addEventListener('resize', () => {
            //     location.reload();
            // });
            autofit.init({
                designWidth: 1920,
                designHeight: 4090,
                renderDom:"#container",
                resize: true
            },false) // 可关闭控制台运行提示输出
        },
        destroyed() {
            autofit.off();
        },
        computed: {
            //计算高度
            computeHeight() {
                let screenHeight = document.body.clientWidth;
                if (screenHeight > 415) {
                    return '47vw';
                } else {
                    return '47vw';
                }
            },

        },
    }
</script>

<style scoped>
    .middle_li {
    transition: all 0.5s; 
    }
    .middle_li:hover {
    transform: scale(1.1); 
    }
    .bg-blue {
        background: #FFFFFF;
box-shadow: 0px 0 11px 0px rgba(164,164,164,0.15);
border-radius: 6px 6px 6px 6px;
    }
    .bg-blue:hover {
    background: rgba(22,109,209,0.8);
box-shadow: 0px 0 11px 0px rgba(164,164,164,0.15);
border-radius: 6px 6px 6px 6px;
    }

    .active1 {
        display: flex;
        align-items: center;
        width: 80%;
        margin-top: 2vh;
        padding: 2vh 1vw;
        box-sizing: border-box;
        background: linear-gradient(to right,#2FA2DC,#31DDBD);;
        color: #fff;
        border-radius: 10px;
        cursor: pointer;
    }
    .unActive1 {
        display: flex;
        align-items: center;
        width: 80%;
        margin-top: 2vh;
        padding: 2vh 1vw;
        box-sizing: border-box;
        background: #D6ECF9;
        color: #111;
        border-radius: 10px;
        cursor: pointer;
    }

    .border_parent {
        width: 90%;
        margin: auto;
    }

    .slider_img {
        height: 47vw;
        width: 100vw;
    }

    .solve {
        margin-top: 30px;
        margin-bottom: 10px
    }

    .border {
        border-radius: 6px;
        border: 1px solid #EBEEF5;
        height: auto;
        margin: 10px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
    }

    .border_one {
        margin-left: 0;
    }

    .border_img_parent {
        margin-top: 20px;
        display: flex;
        justify-content: center;
    }

    .product_mobile_content {
        height: 300px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

    .product_mobile_img {
        width: 50%;
    }

    .product_mobile_title {
        font-weight: bold;
        text-align: center;
    }

    .product_pc_one {
        text-align: center;
        min-height: 400px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .font_size_30 {
        font-size: 1.875em;
    }

    .product_font_style {
        font-size: 1.125em;
    }

    .product_pc_img {
        width: 100%
    }

    .product_pc_img_div {
        width: 50%;
        float: left;
        display: flex;
        align-items: center;
    }

    .product_pc {
        display: flex;
        width: 90%;
        margin: 20px auto;
        background: #F2F6FC;
        align-items: center;
    }

    .product_spec_title {
        margin-top: 30px;
        margin-bottom: 10px
    }

    .product_spec_parent {
        display: flex;
        width: 90%;
        margin: 20px auto;
        align-items: center;
        height: auto
    }

    .cooperation_parent {
        display: flex;
        justify-content: center;
        width: 90%;
        margin: 20px auto;
        align-items: center;
        height: auto
    }

    .border_spec {
        border-radius: 6px;
        border: 1px solid #EBEEF5;
        float: left;
        width: 25%;
        height: auto;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }

    .about_me_p {
        font-size: 1.25em;
        font-weight: normal;
        padding: 0 20px;
        margin: 10px;
    }

    .border_title {
        font-family: "PingFang SC";
        margin-top: 10px;
        font-size: 1.125em;
        font-weight: bold;
        text-align: center;
    }

    .border_content_one {
        margin-top: 20px;
        font-size: 1.125em;
        text-align: center;
    }

    .border_content_two {
        margin-top: 5px;
        font-size: 1.125em;
        margin-bottom: 25px;
        text-align: center;
    }

    .img_border {
        margin-top: 15px;
        width: 80px;
        height: 80px
    }

    .border_spec_inner_one {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 35px;
        height: 70px;
    }

    .border_spec_content_one {
        margin-top: 15px;
        font-size: 1.125em;
        float: left;
        text-align: center;
    }

    .border_spec_inner_last {
        margin-top: 15px;
        font-size: 1.125em;
        float: left;
        margin-bottom: 25px;
        text-align: center;
    }

    .cooperation {
        margin-top: 30px;
        width: 100%;
    }

    .about_me {
        display: flex;
        margin-top: 30px;
        justify-content: center;
        width: 100%;
    }

    .product_mobile {
        width: 90%;
        align-items: center;
        margin: 20px auto;
        background: #F2F6FC;
    }

    .product_mobile_img_div {
        width: 50%;
        height: auto;
    }

    .product_mobile_content_one {
        margin-top: 20px;
        text-align: center;
    }

    .product_mobile_content_two {
        margin-top: 10px;
        text-align: center;
    }

    /* 屏幕设备适配 max-device-width: 400px */
    @media screen and (max-device-width: 415px) {
        .slider_img {
            height: 47vw;
            width: 100%;
        }


        .border_parent {
            display: flex;
            width: 90%;
            margin: auto;
            height: auto;
            flex-direction: column;
        }

        .border {
            border-radius: 6px;
            border: 1px solid #EBEEF5;
            float: left;
            width: 100%;
            height: auto;
            margin: 10px 0 auto;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
            /*background: aquamarine;*/
        }

        .border_img_parent {
            margin-top: 0;

        }

        .product_mobile {
            width: 90%;
            align-items: center;
            margin: 20px auto;
            height: auto;
            background: #F2F6FC;
        }

        .product_mobile_content {
            width: 100%;
            margin-top: 15px;
        }

        .product_mobile_content_one {
            margin-top: 5px;
        }

        .product_mobile_content_two {
            margin-top: 5px;
        }

        .product_mobile_img_div {
            display: flex;
            width: 100%;
            height: auto;
            justify-content: center;
            margin-top: 10px;
            margin-bottom: 15px;
        }

        .product_mobile_img {
            float: left;
        }

        .product_mobile_title {
            font-weight: bold;
        }

        .product_pc_one {
            width: 100%;
            margin-top: 15px;
        }

        .font_size_30 {
            font-size: 1.25em;
        }

        .product_font_style {
            font-size: 1em;
        }

        .product_pc_img {
            height: 280px;
            width: 320px;
        }

        .product_pc_img_div {
            width: 100%;
            float: left;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 15px;
        }

        .product_pc {
            display: flex;
            width: 90%;
            height: auto;
            margin: 20px auto;
            background: #F2F6FC;
            flex-direction: column;
        }

        .head-label {
            display: flex;
            margin-top: 10px;
        }

        .product_spec_parent {
            display: flex;
            width: 90%;
            align-items: center;
            justify-content: center;
            margin: 20px auto;
            height: auto;
            flex-direction: column;
        }

        .border_spec {
            float: left;
            height: auto;
            margin: 8px;
            width: 100%;
            border-radius: 6px;
            border: 1px solid #EBEEF5;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        }


        .border_title {
            font-family: "PingFang SC";
            margin-top: 5px;
            font-size: 1.125em;
            font-weight: bold;
        }

        .border_content_one {
            margin-top: 5px;
            font-size: 1.125em;
        }

        .border_content_two {
            margin-top: 5px;
            font-size: 1.125em;
            margin-bottom: 8px;
        }

        .img_border {
            margin-top: 8px;
            width: 80px;
            height: 80px
        }

        .border_spec_inner_one {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 8px;
            /*background-color: aqua;*/
            height: 70px;
        }

        .border_spec_content_one {
            margin-top: 5px;
            font-size: 1.125em;
            float: left;
        }

        .border_spec_inner_last {
            /*background-color: bisque;*/
            margin-top: 5px;
            font-size: 1.125em;
            float: left;
            margin-bottom: 8px;
        }

        .about_me {
            display: flex;
            margin-top: 10px;
            width: 100%;
        }
    }

    .border_spec_img {
        width: 75px;
        height: 55px;
        align-self: center
    }

    .font_size_24 {
        font-size: 1.5em;
    }
</style>